import React from "react";
import styles from "./styles.module.scss";
import ChevronIcon from "../../assets/svg/icons/common/chevron";

const AccordionItem = ({
  id,
  title,
  subtitle,
  children,
  isExpanded,
  onToggle,
  className = "",
}) => {
  return (
    <div
      className={`${styles.accordionItem} ${className} ${subtitle ? styles.hasSubtitle : ""}`}
    >
      <button
        className={styles.accordionButton}
        onClick={() => onToggle(id)}
        type="button"
      >
        <span className={styles.titleArea}>
          <span
            className={`${styles.arrow} ${isExpanded ? styles.expanded : ""}`}
          >
            <ChevronIcon />
          </span>
          {title}
        </span>

        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
      </button>
      {isExpanded && <div className={styles.accordionContent}>{children}</div>}
    </div>
  );
};

const Accordion = ({
  items,
  expandedItems = [],
  onItemToggle,
  className = "",
}) => {
  return (
    <div className={`${styles.accordion} ${className}`}>
      {items.map((item) => (
        <AccordionItem
          key={item.id}
          id={item.id}
          title={item.title}
          subtitle={item?.subtitle}
          isExpanded={expandedItems.includes(item.id)}
          onToggle={onItemToggle}
          className={styles.item}
        >
          {item.content}
        </AccordionItem>
      ))}
    </div>
  );
};

export default Accordion;
